








































































































import BeaconModel from '@/_models/BeaconModel'
import CardModel from '@/_models/CardModel'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
})
export default class DisplayCamera extends Vue {
  @Prop() beaconSelectedId!: string
  @Prop() beaconsDevices!: Array<BeaconModel | CardModel>

  isImageModalActive: boolean = false
  bigImg: string = ''
  multipleViewImgs: any[] = []
  activeTab: number = 0

  selected: any = new BeaconModel()

  @Watch('selected') cameraSelectedChange(value: BeaconModel | CardModel) {
    if (this.multipleViewImgs.length) {
      this.multipleViewImgs = this.multipleViewImgs.filter((item) => item._id !== value._id)
    }
  }

  mounted() {
    this.selected = this.beaconsDevices.find((item) => item._id === this.beaconSelectedId)
  }

  selectBeacon(beacon: BeaconModel | CardModel) {
    if (!beacon.camera_address) {
      return
    }

    this.selected = beacon
  }

  addToMultipleView(beacon: BeaconModel | CardModel, index: number) {
    const multipleCameraAddress = this.multipleViewImgs.map((item) => item.camera_address)

    if (!multipleCameraAddress.includes(beacon.camera_address)) {
      this.multipleViewImgs.push({
        ...beacon,
        number: index,
      })
    }
  }

  isExistInMultiple(beaconId: string): boolean {
    return this.multipleViewImgs.some((item) => item._id === beaconId)
  }

  removeFromMutiple(beaconId: string) {
    this.multipleViewImgs = this.multipleViewImgs.filter((item) => item._id !== beaconId)
  }

  openBiggerModal(cameraAddress: string) {
    this.isImageModalActive = true
    this.bigImg = cameraAddress
  }

  imgPlaceholder(event) {
    event.target.src = 'https://i.pinimg.com/originals/d0/f8/78/d0f878e457ee6254b07bfb928886941d.png'
  }
}
